/* Automatically generated by './build/bin/build-entry.js' */
import './styles/index.scss';
import 'vue-loading-overlay/dist/vue-loading.css';
import AAlert from './components/atoms/alert/index.js';
import AApplicationCompleteSign from './components/atoms/application-complete-sign/index.js';
import AApplicationSummaryItem from './components/atoms/application-summary-item/index.js';
import AAudioPlayerControl from './components/atoms/audio-player-control/index.js';
import AAudioPlayerProgressBar from './components/atoms/audio-player-progress-bar/index.js';
import AAvatar from './components/atoms/avatar/index.js';
import ABrandLogo from './components/atoms/brand-logo/index.js';
import ABusinessHourInputField from './components/atoms/business-hour-input-field/index.js';
import AButton from './components/atoms/button/index.js';
import ACalendarField from './components/atoms/calendar-field/index.js';
import ACallingActionButton from './components/atoms/calling-action-button/index.js';
import ACallingCustomerInfo from './components/atoms/calling-customer-info/index.js';
import ACallingResponseStatus from './components/atoms/calling-response-status/index.js';
import ACallingStatus from './components/atoms/calling-status/index.js';
import ACaptionList from './components/atoms/caption-list/index.js';
import ACheckbox from './components/atoms/checkbox/index.js';
import ACurrentPhone from './components/atoms/current-phone/index.js';
import ADataListItem from './components/atoms/data-list-item/index.js';
import ADataTableBody from './components/atoms/data-table-body/index.js';
import ADataTableColumn from './components/atoms/data-table-column/index.js';
import ADataTableHeader from './components/atoms/data-table-header/index.js';
import AErrorBalloon from './components/atoms/error-balloon/index.js';
import AExpiryDateField from './components/atoms/expiry-date-field/index.js';
import AFrequentlyUsedContactButton from './components/atoms/frequently-used-contact-button/index.js';
import AHeading from './components/atoms/heading/index.js';
import AIcon from './components/atoms/icon/index.js';
import AListGroupHeader from './components/atoms/list-group-header/index.js';
import AListItem from './components/atoms/list-item/index.js';
import ALoading from './components/atoms/loading/index.js';
import AModalFooter from './components/atoms/modal-footer/index.js';
import AModalHeader from './components/atoms/modal-header/index.js';
import ANavigationItem from './components/atoms/navigation-item/index.js';
import APageHeading from './components/atoms/page-heading/index.js';
import APagination from './components/atoms/pagination/index.js';
import APhoneDialField from './components/atoms/phone-dial-field/index.js';
import APriceTableHeader from './components/atoms/price-table-header/index.js';
import APriceTableRow from './components/atoms/price-table-row/index.js';
import AProgressStep from './components/atoms/progress-step/index.js';
import ARadio from './components/atoms/radio/index.js';
import AResponseFlowSummaryItem from './components/atoms/response-flow-summary-item/index.js';
import ASectionDivider from './components/atoms/section-divider/index.js';
import ASelectField from './components/atoms/select-field/index.js';
import ASummaryItemHeader from './components/atoms/summary-item-header/index.js';
import ASwitch from './components/atoms/switch/index.js';
import ATabNav from './components/atoms/tab-nav/index.js';
import ATabPane from './components/atoms/tab-pane/index.js';
import ATag from './components/atoms/tag/index.js';
import ATextField from './components/atoms/text-field/index.js';
import AText from './components/atoms/text/index.js';
import AUomText from './components/atoms/uom-text/index.js';
import AUploadField from './components/atoms/upload-field/index.js';
import AVdxbAlert from './components/atoms/vdxb-alert/index.js';
import AVdxbApplicationCompleteSign from './components/atoms/vdxb-application-complete-sign/index.js';
import AVdxbApplicationSummaryItem from './components/atoms/vdxb-application-summary-item/index.js';
import AVdxbBrandLogo from './components/atoms/vdxb-brand-logo/index.js';
import AVdxbButton from './components/atoms/vdxb-button/index.js';
import AVdxbCaptionList from './components/atoms/vdxb-caption-list/index.js';
import AVdxbCheckbox from './components/atoms/vdxb-checkbox/index.js';
import AVdxbErrorBalloon from './components/atoms/vdxb-error-balloon/index.js';
import AVdxbHeading from './components/atoms/vdxb-heading/index.js';
import AVdxbIcon from './components/atoms/vdxb-icon/index.js';
import AVdxbModalHeader from './components/atoms/vdxb-modal-header/index.js';
import AVdxbProgressStep from './components/atoms/vdxb-progress-step/index.js';
import AVdxbRadio from './components/atoms/vdxb-radio/index.js';
import AVdxbSectionDivider from './components/atoms/vdxb-section-divider/index.js';
import AVdxbSelectField from './components/atoms/vdxb-select-field/index.js';
import AVdxbText from './components/atoms/vdxb-text/index.js';
import AVdxbTextField from './components/atoms/vdxb-text-field/index.js';
import AVdxbUploadField from './components/atoms/vdxb-upload-field/index.js';
import ANoticeHeader from './components/atoms/notice-header/index.js';
import ANoticeListItem from './components/atoms/notice-list-item/index.js';
import ASfCallingActionButton from './components/atoms/sf-calling-action-button/index.js';
import ASfCallingCustomerInfo from './components/atoms/sf-calling-customer-info/index.js';
import ASfCallingStatus from './components/atoms/sf-calling-status/index.js';
import MActionCard from './components/molecules/action-card/index.js';
import MApplicationSummary from './components/molecules/application-summary/index.js';
import MAudioPlayer from './components/molecules/audio-player/index.js';
import MAutomaticResponderSetting from './components/molecules/automatic-responder-setting/index.js';
import MBusinessHourSettingItem from './components/molecules/business-hour-setting-item/index.js';
import MButtonContainer from './components/molecules/button-container/index.js';
import MCalendarRangeField from './components/molecules/calendar-range-field/index.js';
import MCallingActionButtonList from './components/molecules/calling-action-button-list/index.js';
import MCallingPendingAgents from './components/molecules/calling-pending-agents/index.js';
import MCardFilter from './components/molecules/card-filter/index.js';
import MCardList from './components/molecules/card-list/index.js';
import MContactSummaryBar from './components/molecules/contact-summary-bar/index.js';
import MCurrentUserStatus from './components/molecules/current-user-status/index.js';
import MDataList from './components/molecules/data-list/index.js';
import MDataTable from './components/molecules/data-table/index.js';
import MDubbingResponderSetting from './components/molecules/dubbing-responder-setting/index.js';
import MFilterDialog from './components/molecules/filter-dialog/index.js';
import MFormActionButtons from './components/molecules/form-action-buttons/index.js';
import MFormInput from './components/molecules/form-input/index.js';
import MHolidaySettingItem from './components/molecules/holiday-setting-item/index.js';
import MLinkContainer from './components/molecules/link-container/index.js';
import MListGroup from './components/molecules/list-group/index.js';
import MNavigation from './components/molecules/navigation/index.js';
import MNumpad from './components/molecules/numpad/index.js';
import MPaymentRadio from './components/molecules/payment-radio/index.js';
import MPriceTable from './components/molecules/price-table/index.js';
import MProgress from './components/molecules/progress/index.js';
import MResponseFlowItem from './components/molecules/response-flow-item/index.js';
import MResponseFlowSummary from './components/molecules/response-flow-summary/index.js';
import MSection from './components/molecules/section/index.js';
import MSpecialBusinessDaySettingItem from './components/molecules/special-business-day-setting-item/index.js';
import MTab from './components/molecules/tab/index.js';
import MUserInvitationItem from './components/molecules/user-invitation-item/index.js';
import MUserInvitationList from './components/molecules/user-invitation-list/index.js';
import MUserInvitationRadio from './components/molecules/user-invitation-radio/index.js';
import MUserInvitationUploadRadio from './components/molecules/user-invitation-upload-radio/index.js';
import MUserSelectionTable from './components/molecules/user-selection-table/index.js';
import MSfCurrentUserStatus from './components/molecules/sf-current-user-status/index.js';
import OBusinessHourSettingList from './components/organisms/business-hour-setting-list/index.js';
import OCallingModal from './components/organisms/calling-modal/index.js';
import OGlobalFooter from './components/organisms/global-footer/index.js';
import OGlobalSidebar from './components/organisms/global-sidebar/index.js';
import OHolidaySettingList from './components/organisms/holiday-setting-list/index.js';
import OIncomingCallModal from './components/organisms/incoming-call-modal/index.js';
import OModal from './components/organisms/modal/index.js';
import OOutgoingCallModal from './components/organisms/outgoing-call-modal/index.js';
import OPhoneDialWindow from './components/organisms/phone-dial-window/index.js';
import OPhoneDial from './components/organisms/phone-dial/index.js';
import OResponseFlowSettingList from './components/organisms/response-flow-setting-list/index.js';
import OSpecialBusinessDaySettingList from './components/organisms/special-business-day-setting-list/index.js';
import OVdxbModal from './components/organisms/vdxb-modal/index.js';
import OSfSidebar from './components/organisms/sf-sidebar/index.js';
import OSfPhoneDial from './components/organisms/sf-phone-dial/index.js';
import OSfIncomingCallModal from './components/organisms/sf-incoming-call-modal/index.js';
import OSfCallingModal from './components/organisms/sf-calling-modal/index.js';
import ONotice from './components/organisms/notice/index.js';
import TApplicationInviteUserForm from './components/templates/application-invite-user-form/index.js';
import TApplicationInviteUserPayment from './components/templates/application-invite-user-payment/index.js';
import TApplicationInviteUserRegistrationComplete from './components/templates/application-invite-user-registration-complete/index.js';
import TApplicationInviteUserSmsVerifyOtpInput from './components/templates/application-invite-user-sms-verify-otp-input/index.js';
import TApplicationInviteUserSmsVerifyPhoneNumberInput from './components/templates/application-invite-user-sms-verify-phone-number-input/index.js';
import TApplicationInviteUserSummary from './components/templates/application-invite-user-summary/index.js';
import TApplicationInviteUserUpload from './components/templates/application-invite-user-upload/index.js';
import TApplicationInviteUser from './components/templates/application-invite-user/index.js';
import TVdxbApplicationInviteUser from './components/templates/vdxb-application-invite-user/index.js';
import TVdxbApplicationInviteUserForm from './components/templates/vdxb-application-invite-user-form/index.js';
import TVdxbApplicationInviteUserUpload from './components/templates/vdxb-application-invite-user-upload/index.js';
import TVdxbApplicationInviteUserFormHoujin from './components/templates/vdxb-application-invite-user-form-houjin/index.js';
import TVdxbApplicationInviteUserUploadHoujin from './components/templates/vdxb-application-invite-user-upload-houjin/index.js';
import TVdxbApplicationInviteUserInvoice from './components/templates/vdxb-application-invite-user-invoice/index.js';
import TVdxbApplicationInviteUserSummary from './components/templates/vdxb-application-invite-user-summary/index.js';
import TVdxbApplicationInviteUserRegistrationComplete from './components/templates/vdxb-application-invite-user-registration-complete/index.js';
import TTrialApplicationInviteUser from './components/templates/trial-application-invite-user/index.js';
import TTrialApplicationInviteUserForm from './components/templates/trial-application-invite-user-form/index.js';
import TTrialApplicationInviteUserSummary from './components/templates/trial-application-invite-user-summary/index.js';
import TTrialApplicationInviteUserRegistrationComplete from './components/templates/trial-application-invite-user-registration-complete/index.js';
import TTrialDefaultEntry from './components/templates/trial-default-entry/index.js';
import TContractEditCancelAccount from './components/templates/contract-edit-cancel-account/index.js';
import TContractEditCancelComplete from './components/templates/contract-edit-cancel-complete/index.js';
import TContractEditContractorInfo from './components/templates/contract-edit-contractor-info/index.js';
import TContractEditPayment from './components/templates/contract-edit-payment/index.js';
import TContractEditPhoneNumber from './components/templates/contract-edit-phone-number/index.js';
import TContractList from './components/templates/contract-list/index.js';
import TDefaultEntrySidebar from './components/templates/default-entry-sidebar/index.js';
import TDefaultEntry from './components/templates/default-entry/index.js';
import TVdxbDefaultEntrySidebar from './components/templates/vdxb-default-entry-sidebar/index.js';
import TVdxbDefaultEntry from './components/templates/vdxb-default-entry/index.js';
import TDefaultLayout from './components/templates/default-layout/index.js';
import TError from './components/templates/error/index.js';
import THistoryDetail from './components/templates/history-detail/index.js';
import THistoryList from './components/templates/history-list/index.js';
import THome from './components/templates/home/index.js';
import TLoginInvitedUserPasswordInvitedUserPassword from './components/templates/login-invited-user-password/index.js';
import TLoginInvitedUserSetPassword from './components/templates/login-invited-user-set-password/index.js';
import TLoginInvitedUserSms from './components/templates/login-invited-user-sms/index.js';
import TLogin from './components/templates/login/index.js';
import TPhoneBookAddByUploadingFile from './components/templates/phone-book-add-by-uploading-file/index.js';
import TPhoneBookAddOneByOne from './components/templates/phone-book-add-one-by-one/index.js';
import TPhoneBookDetail from './components/templates/phone-book-detail/index.js';
import TPhoneBookList from './components/templates/phone-book-list/index.js';
import TPriceHistoryDetail from './components/templates/price-history-detail/index.js';
import TPriceHistoryList from './components/templates/price-history-list/index.js';
import TProfileEditPassword from './components/templates/profile-edit-password/index.js';
import TProfileEditSms from './components/templates/profile-edit-sms/index.js';
import TProfileEditUserInfo from './components/templates/profile-edit-user-info/index.js';
import TProfileList from './components/templates/profile-list/index.js';
import TSettingBusinessHoursEditBusinessHours from './components/templates/setting-business-hours-edit-business-hours/index.js';
import TSettingBusinessHoursEditHoliday from './components/templates/setting-business-hours-edit-holiday/index.js';
import TSettingBusinessHoursEditHoursOnHolidayResponse from './components/templates/setting-business-hours-edit-hours-on-holiday-response/index.js';
import TSettingBusinessHoursEditHoursOnHoliday from './components/templates/setting-business-hours-edit-hours-on-holiday/index.js';
import TSettingBusinessList from './components/templates/setting-business-list/index.js';
import TSettingIvrEdit from './components/templates/setting-ivr-edit/index.js';
import TSettingIvrList from './components/templates/setting-ivr-list/index.js';
import TSettingSms from './components/templates/setting-sms/index.js';
import TSettingUserGroupsCreate from './components/templates/setting-user-groups-create/index.js';
import TSettingUserGroupsEdit from './components/templates/setting-user-groups-edit/index.js';
import TSettingUserList from './components/templates/setting-user-list/index.js';
import TSettingUsersAdd from './components/templates/setting-users-add/index.js';
import TSettingUsersEdit from './components/templates/setting-users-edit/index.js';
import TWalkthroughBusinessHoursDateTime from './components/templates/walkthrough-business-hours-date-time/index.js';
import TWalkthroughBusinessHoursGuidance from './components/templates/walkthrough-business-hours-guidance/index.js';
import TWalkthroughComplete from './components/templates/walkthrough-complete/index.js';
import TWalkthroughInviteUser from './components/templates/walkthrough-invite-user/index.js';
import TWalkthroughIvrGuidance from './components/templates/walkthrough-ivr-guidance/index.js';
import TWalkthroughIvrUserGroup from './components/templates/walkthrough-ivr-user-group/index.js';
import TWalkthroughRoutingUserGroup from './components/templates/walkthrough-routing-user-group/index.js';
import TWalkthroughSelectBusinessHours from './components/templates/walkthrough-select-business-hours/index.js';
import TWalkthroughSelectIvr from './components/templates/walkthrough-select-ivr/index.js';
import TCompanymgmt from './components/templates/setting-company-list/index.js';
import TCompanyAdd from './components/templates/setting-company-add/index.js';
import TLanding from './components/templates/landing/index.js';
import TCompanyRequest from './components/templates/setting-company-request/index.js';
import TSfLogin from './components/templates/sf-login/index.js';
import TSfHome from './components/templates/sf-home/index.js';
import TSfDefaultLayout from './components/templates/sf-default-layout/index.js';
import TSfDefaultEntry from './components/templates/sf-default-entry/index.js';

const components = [
  AAlert,
  AApplicationCompleteSign,
  AApplicationSummaryItem,
  AAudioPlayerControl,
  AAudioPlayerProgressBar,
  AAvatar,
  ABrandLogo,
  ABusinessHourInputField,
  AButton,
  ACalendarField,
  ACallingActionButton,
  ACallingCustomerInfo,
  ACallingResponseStatus,
  ACallingStatus,
  ACaptionList,
  ACheckbox,
  ACurrentPhone,
  ADataListItem,
  ADataTableBody,
  ADataTableColumn,
  ADataTableHeader,
  AErrorBalloon,
  AExpiryDateField,
  AFrequentlyUsedContactButton,
  AHeading,
  AIcon,
  AListGroupHeader,
  AListItem,
  ALoading,
  AModalFooter,
  AModalHeader,
  ANavigationItem,
  APageHeading,
  APagination,
  APhoneDialField,
  APriceTableHeader,
  APriceTableRow,
  AProgressStep,
  ARadio,
  AResponseFlowSummaryItem,
  ASectionDivider,
  ASelectField,
  ASummaryItemHeader,
  ASwitch,
  ATabNav,
  ATabPane,
  ATag,
  ATextField,
  AText,
  AUomText,
  AUploadField,
  AVdxbAlert,
  AVdxbApplicationCompleteSign,
  AVdxbApplicationSummaryItem,
  AVdxbBrandLogo,
  AVdxbButton,
  AVdxbCaptionList,
  AVdxbCheckbox,
  AVdxbErrorBalloon,
  AVdxbHeading,
  AVdxbIcon,
  AVdxbModalHeader,
  AVdxbProgressStep,
  AVdxbRadio,
  AVdxbSectionDivider,
  AVdxbSelectField,
  AVdxbText,
  AVdxbTextField,
  AVdxbUploadField,
  ANoticeHeader,
  ANoticeListItem,
  ASfCallingActionButton,
  ASfCallingCustomerInfo,
  ASfCallingStatus,
  MActionCard,
  MApplicationSummary,
  MAudioPlayer,
  MAutomaticResponderSetting,
  MBusinessHourSettingItem,
  MButtonContainer,
  MCalendarRangeField,
  MCallingActionButtonList,
  MCallingPendingAgents,
  MCardFilter,
  MCardList,
  MContactSummaryBar,
  MCurrentUserStatus,
  MDataList,
  MDataTable,
  MDubbingResponderSetting,
  MFilterDialog,
  MFormActionButtons,
  MFormInput,
  MHolidaySettingItem,
  MLinkContainer,
  MListGroup,
  MNavigation,
  MNumpad,
  MPaymentRadio,
  MPriceTable,
  MProgress,
  MResponseFlowItem,
  MResponseFlowSummary,
  MSection,
  MSpecialBusinessDaySettingItem,
  MTab,
  MUserInvitationItem,
  MUserInvitationList,
  MUserInvitationRadio,
  MUserInvitationUploadRadio,
  MUserSelectionTable,
  MSfCurrentUserStatus,
  OBusinessHourSettingList,
  OCallingModal,
  OGlobalFooter,
  OGlobalSidebar,
  OHolidaySettingList,
  OIncomingCallModal,
  OModal,
  OPhoneDialWindow,
  OPhoneDial,
  OResponseFlowSettingList,
  OSpecialBusinessDaySettingList,
  OVdxbModal,
  OSfSidebar,
  OSfPhoneDial,
  OSfIncomingCallModal,
  OSfCallingModal,
  ONotice,
  TApplicationInviteUserForm,
  TApplicationInviteUserPayment,
  TApplicationInviteUserRegistrationComplete,
  TApplicationInviteUserSmsVerifyOtpInput,
  TApplicationInviteUserSmsVerifyPhoneNumberInput,
  TApplicationInviteUserSummary,
  TApplicationInviteUserUpload,
  TApplicationInviteUser,
  TVdxbApplicationInviteUser,
  TVdxbApplicationInviteUserForm,
  TVdxbApplicationInviteUserUpload,
  TVdxbApplicationInviteUserFormHoujin,
  TVdxbApplicationInviteUserUploadHoujin,
  TVdxbApplicationInviteUserInvoice,
  TVdxbApplicationInviteUserSummary,
  TVdxbApplicationInviteUserRegistrationComplete,
  TTrialApplicationInviteUser,
  TTrialApplicationInviteUserForm,
  TTrialApplicationInviteUserSummary,
  TTrialApplicationInviteUserRegistrationComplete,
  TTrialDefaultEntry,
  TContractEditCancelAccount,
  TContractEditCancelComplete,
  TContractEditContractorInfo,
  TContractEditPayment,
  TContractEditPhoneNumber,
  TContractList,
  TDefaultEntrySidebar,
  TDefaultEntry,
  TVdxbDefaultEntrySidebar,
  TVdxbDefaultEntry,
  TDefaultLayout,
  TError,
  THistoryDetail,
  THistoryList,
  THome,
  TLoginInvitedUserPasswordInvitedUserPassword,
  TLoginInvitedUserSetPassword,
  TLoginInvitedUserSms,
  TLogin,
  TPhoneBookAddByUploadingFile,
  TPhoneBookAddOneByOne,
  TPhoneBookDetail,
  TPhoneBookList,
  TPriceHistoryDetail,
  TPriceHistoryList,
  TProfileEditPassword,
  TProfileEditSms,
  TProfileEditUserInfo,
  TProfileList,
  TSettingBusinessHoursEditBusinessHours,
  TSettingBusinessHoursEditHoliday,
  TSettingBusinessHoursEditHoursOnHolidayResponse,
  TSettingBusinessHoursEditHoursOnHoliday,
  TSettingBusinessList,
  TSettingIvrEdit,
  TSettingIvrList,
  TSettingSms,
  TSettingUserGroupsCreate,
  TSettingUserGroupsEdit,
  TSettingUserList,
  TSettingUsersAdd,
  TSettingUsersEdit,
  TWalkthroughBusinessHoursDateTime,
  TWalkthroughBusinessHoursGuidance,
  TWalkthroughComplete,
  TWalkthroughInviteUser,
  TWalkthroughIvrGuidance,
  TWalkthroughIvrUserGroup,
  TWalkthroughRoutingUserGroup,
  TWalkthroughSelectBusinessHours,
  TWalkthroughSelectIvr,
  TCompanymgmt,
  TCompanyAdd,
  TLanding,
  TCompanyRequest,
  TSfLogin,
  TSfHome,
  TSfDefaultLayout,
  TSfDefaultEntry,
];

const install = function (app) {
  components.forEach(component => {
    app.component(component.name, component);
  });
};

export default {
  install,
  AAlert,
  AApplicationCompleteSign,
  AApplicationSummaryItem,
  AAudioPlayerControl,
  AAudioPlayerProgressBar,
  AAvatar,
  ABrandLogo,
  ABusinessHourInputField,
  AButton,
  ACalendarField,
  ACallingActionButton,
  ACallingCustomerInfo,
  ACallingResponseStatus,
  ACallingStatus,
  ACaptionList,
  ACheckbox,
  ACurrentPhone,
  ADataListItem,
  ADataTableBody,
  ADataTableColumn,
  ADataTableHeader,
  AErrorBalloon,
  AExpiryDateField,
  AFrequentlyUsedContactButton,
  AHeading,
  AIcon,
  AListGroupHeader,
  AListItem,
  ALoading,
  AModalFooter,
  AModalHeader,
  ANavigationItem,
  APageHeading,
  APagination,
  APhoneDialField,
  APriceTableHeader,
  APriceTableRow,
  AProgressStep,
  ARadio,
  AResponseFlowSummaryItem,
  ASectionDivider,
  ASelectField,
  ASummaryItemHeader,
  ASwitch,
  ATabNav,
  ATabPane,
  ATag,
  ATextField,
  AText,
  AUomText,
  AUploadField,
  AVdxbAlert,
  AVdxbApplicationCompleteSign,
  AVdxbApplicationSummaryItem,
  AVdxbBrandLogo,
  AVdxbButton,
  AVdxbCaptionList,
  AVdxbCheckbox,
  AVdxbErrorBalloon,
  AVdxbHeading,
  AVdxbIcon,
  AVdxbModalHeader,
  AVdxbProgressStep,
  AVdxbRadio,
  AVdxbSectionDivider,
  AVdxbSelectField,
  AVdxbText,
  AVdxbTextField,
  AVdxbUploadField,
  ANoticeHeader,
  ANoticeListItem,
  ASfCallingActionButton,
  ASfCallingCustomerInfo,
  ASfCallingStatus,
  MActionCard,
  MApplicationSummary,
  MAudioPlayer,
  MAutomaticResponderSetting,
  MBusinessHourSettingItem,
  MButtonContainer,
  MCalendarRangeField,
  MCallingActionButtonList,
  MCallingPendingAgents,
  MCardFilter,
  MCardList,
  MContactSummaryBar,
  MCurrentUserStatus,
  MDataList,
  MDataTable,
  MDubbingResponderSetting,
  MFilterDialog,
  MFormActionButtons,
  MFormInput,
  MHolidaySettingItem,
  MLinkContainer,
  MListGroup,
  MNavigation,
  MNumpad,
  MPaymentRadio,
  MPriceTable,
  MProgress,
  MResponseFlowItem,
  MResponseFlowSummary,
  MSection,
  MSpecialBusinessDaySettingItem,
  MTab,
  MUserInvitationItem,
  MUserInvitationList,
  MUserInvitationRadio,
  MUserInvitationUploadRadio,
  MUserSelectionTable,
  MSfCurrentUserStatus,
  OBusinessHourSettingList,
  OCallingModal,
  OGlobalFooter,
  OGlobalSidebar,
  OHolidaySettingList,
  OIncomingCallModal,
  OModal,
  OPhoneDialWindow,
  OPhoneDial,
  OResponseFlowSettingList,
  OSpecialBusinessDaySettingList,
  OVdxbModal,
  OSfSidebar,
  OSfPhoneDial,
  OSfIncomingCallModal,
  OSfCallingModal,
  ONotice,
  TApplicationInviteUserForm,
  TApplicationInviteUserPayment,
  TApplicationInviteUserRegistrationComplete,
  TApplicationInviteUserSmsVerifyOtpInput,
  TApplicationInviteUserSmsVerifyPhoneNumberInput,
  TApplicationInviteUserSummary,
  TApplicationInviteUserUpload,
  TApplicationInviteUser,
  TVdxbApplicationInviteUser,
  TVdxbApplicationInviteUserForm,
  TVdxbApplicationInviteUserUpload,
  TVdxbApplicationInviteUserFormHoujin,
  TVdxbApplicationInviteUserUploadHoujin,
  TVdxbApplicationInviteUserInvoice,
  TVdxbApplicationInviteUserSummary,
  TVdxbApplicationInviteUserRegistrationComplete,
  TTrialApplicationInviteUser,
  TTrialApplicationInviteUserForm,
  TTrialApplicationInviteUserSummary,
  TTrialApplicationInviteUserRegistrationComplete,
  TTrialDefaultEntry,
  TContractEditCancelAccount,
  TContractEditCancelComplete,
  TContractEditContractorInfo,
  TContractEditPayment,
  TContractEditPhoneNumber,
  TContractList,
  TDefaultEntrySidebar,
  TDefaultEntry,
  TVdxbDefaultEntrySidebar,
  TVdxbDefaultEntry,
  TDefaultLayout,
  TError,
  THistoryDetail,
  THistoryList,
  THome,
  TLoginInvitedUserPasswordInvitedUserPassword,
  TLoginInvitedUserSetPassword,
  TLoginInvitedUserSms,
  TLogin,
  TPhoneBookAddByUploadingFile,
  TPhoneBookAddOneByOne,
  TPhoneBookDetail,
  TPhoneBookList,
  TPriceHistoryDetail,
  TPriceHistoryList,
  TProfileEditPassword,
  TProfileEditSms,
  TProfileEditUserInfo,
  TProfileList,
  TSettingBusinessHoursEditBusinessHours,
  TSettingBusinessHoursEditHoliday,
  TSettingBusinessHoursEditHoursOnHolidayResponse,
  TSettingBusinessHoursEditHoursOnHoliday,
  TSettingBusinessList,
  TSettingIvrEdit,
  TSettingIvrList,
  TSettingSms,
  TSettingUserGroupsCreate,
  TSettingUserGroupsEdit,
  TSettingUserList,
  TSettingUsersAdd,
  TSettingUsersEdit,
  TWalkthroughBusinessHoursDateTime,
  TWalkthroughBusinessHoursGuidance,
  TWalkthroughComplete,
  TWalkthroughInviteUser,
  TWalkthroughIvrGuidance,
  TWalkthroughIvrUserGroup,
  TWalkthroughRoutingUserGroup,
  TWalkthroughSelectBusinessHours,
  TWalkthroughSelectIvr,
  TCompanymgmt,
  TCompanyAdd,
  TLanding,
  TCompanyRequest,
  TSfLogin,
  TSfHome,
  TSfDefaultLayout,
  TSfDefaultEntry,
};
